export default "__VITE_ASSET__Bae2$azM__"